<template>
  <transition-group
    :tag="tag"
    type="animation"
    enter-class="list-transition-animate--enter"
    enter-active-class="list-transition-animate--enter-active"
    leave-active-class="list-transition-animate--leave-active"
    move-class="list-transition-animate--move">
    <slot></slot>
  </transition-group>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
};
</script>

<style lang="stylus">

$transition-time = 0.5s;

.list-transition-animate--enter, .list-transition-animate--leave-active {
  // since scoped style may not be replaced, use !important to force change style.
  opacity: 0 !important;
}

.list-transition-animate--enter-active , .list-transition-animate--leave-active {
  // since scoped style may not be replaced, use !important to force change style.
  transition: $transition-time;
}

.list-transition-animate--enter-active {
  animation-name: slidedown;
  animation-duration: $transition-time;
}

.list-transition-animate--leave-active {
  animation-name: slideup;
  animation-duration: $transition-time;

  position: absolute !important;
  // since the container does not define specific width, when the position of item change to absolute,
  // the width of item will change as small as it can, that's why need to define 'width: 100%'
  // to make item to keep it's original width.
  width: 100%;
}

// this style will be applied to all items which position need to be changed.
.list-transition-animate--move {
  transition: transform $transition-time;
}

@keyframes slidedown {
  0% {
    transform: translateY(-50%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideup {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-50%);
    opacity: 0;
  }
}

</style>
